import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { EmptyMessageCtn, CreateAddressbookBtn, AddButtonLabel } from './styles';

const EmptyAddressbooksMsg = () => (
  <EmptyMessageCtn>
    <Typography variant="h6" gutterBottom>
      You don&apos;t have an address book to add a contact.
    </Typography>
    <CreateAddressbookBtn
      size="small"
      color="secondary"
      aria-label="Create address book"
      component={Link}
      to="/addressbook/create"
    >
      <AddIcon />
      <AddButtonLabel>Create address book</AddButtonLabel>
    </CreateAddressbookBtn>
  </EmptyMessageCtn>
);

export default EmptyAddressbooksMsg;
